import { useEffect, useState } from "react";
import CustomInput from "@components/CustomInput/CustomInput";
import EmailInvite from "@assets/svg/EmailInvite";
import DeleteIcon from "@assets/svg/DeleteIcon";
import CancelInviteIcon from "@assets/svg/CancelInviteIcon";
import {
  addNewReferral,
  getReferral,
  getReferralRequests,
  deleteReferral,
  removeReferral,
  finalConfirmation,
} from "@endpoints/candidate.service";
import ProfileImg from "@assets/images/profilepic.png";

import { useSnackbar } from "notistack";
import {
  getReferralByName,
  referralRequestActionApi,
  updateReferralAccountApi,
} from "@endpoints/referral.service";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { isNullOrEmpty } from "@utils/helperFunction";
import SearchIcon from "@assets/svg/SearchIcon";
import LoadingAnimation from "@assets/svg/LoadingAnimation";
import userImg from "@assets/images/emptyUser.png";
import ReferralMemberMessages from "./ReferralMemberMessages";
import CheckMark from "@assets/svg/CheckMark";
import CrossMark from "@assets/svg/CrossMark";
import { colors } from "@nextui-org/theme";
import dayjs from "@lib/dayjs";

const ReferralMemberPage = () => {
  const [activeTab, setActiveTab] = useState("invites");
  const { user } = useSelector((state) => state.auth);
  const [isCancelInviteModal, setIsCancelInviteModal] = useState(false);
  const [isRemoveReferralModal, setIsRemoveReferralModal] = useState(false);
  const [isChangeReferralModalOpen, setIsChangeReferralModalOpen] =
    useState(false);
  const [isInviteModal, setIsInviteModal] = useState(false);
  const [selectedReferralId, setSelectedReferralId] = useState(null);
  const [selectedReferralMemberId, setSelectedReferralMemberId] =
    useState(null);
  const [referralRequestData, setReferralRequestData] = useState();
  const [referralMember, setReferralMember] = useState();
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [loadingId, setLoadingId] = useState(undefined);

  const {
    control,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      email: user?.email,
      userName: user?.userName,
      referralName: !isNullOrEmpty(user?.referralDetail?.firstName)
        ? user?.referralDetail?.firstName + " " + user?.referralDetail?.lastName
        : "",
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      inviteReferralAccountEmail: undefined,
      isLoadingInviteReferaalAccount: false,
    },
  });

  useEffect(() => {
    if (user) {
      reset({
        firstName: user?.firstName,
        lastName: user?.lastName,
        email: user?.email,
        phoneNo: user?.phoneNo ?? "N/A",
        userName: user?.userName,
        referralName: !isNullOrEmpty(user?.referralDetail?.firstName)
          ? user?.referralDetail?.firstName +
            " " +
            user?.referralDetail?.lastName
          : "",
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
        refferalAccounts: [],
      });
    }
  }, [user]);

  const fields = watch();

  useEffect(() => {
    getReferralDetail();
    getAllReferralRequests();
  }, []);

  useEffect(() => {
    if (!isNullOrEmpty(fields?.changeReferralName)) {
      onRefferalAccountSearch(fields?.changeReferralName);
    }
  }, [fields?.changeReferralName]);

  const onRefferalAccountSearch = async (name) => {
    try {
      const { data } = await getReferralByName(name);
      setValue("refferalAccounts", data);
    } catch (error) {}
  };

  const handleColseInviteModal = () => {
    setIsInviteModal(false);
  };

  const handleCloseInviteModal = () => {
    setIsCancelInviteModal(false);
  };

  const handleChangeReferralClick = () => {
    setIsChangeReferralModalOpen(true);
  };
  const handleChangeReferralModal = () => {
    setIsChangeReferralModalOpen(false);
  };

  const getReferralDetail = async () => {
    try {
      const { data } = await getReferral();

      setReferralMember(data?.[0]);
    } catch (error) {
      enqueueSnackbar(error, {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const getAllReferralRequests = async () => {
    try {
      const { data } = await getReferralRequests();
      setReferralRequestData(data);
    } catch (error) {}
  };

  const notificationRequestAction = async ({ requestId, action }) => {
    setIsLoading({ _id: requestId, action });
    try {
      const data = await referralRequestActionApi({ requestId, action });
      await getAllReferralRequests();
    } catch (e) {
      console.error("Action failed:", e);
    } finally {
      setIsLoading(undefined);
    }
  };

  const resendNewReferral = async (params) => {
    try {
      const { success } = await addNewReferral(params);
      if (success) {
        enqueueSnackbar("Invited sucessfully.", {
          variant: "success",
        });
        setIsInviteModal(true);
      }
    } catch (error) {
      enqueueSnackbar(error, {
        variant: "error",
      });
    } finally {
    }
  };

  const finalReferralConfirmation = async (requestId) => {
    setLoadingId(requestId);
    try {
      const { success, data } = await finalConfirmation(requestId);
      if (success) {
        getReferralDetail();
        getAllReferralRequests();
        enqueueSnackbar("Invited sucessfully.", {
          variant: "success",
        });
      }
    } catch (error) {
      enqueueSnackbar(error, {
        variant: "error",
      });
    } finally {
      setLoadingId(undefined);
    }
  };

  const updateReferralAccount = async (params) => {
    try {
      const { success } = await updateReferralAccountApi(params);
      if (success) {
        enqueueSnackbar("Invited sucessfully.", {
          variant: "success",
        });
        setIsChangeReferralModalOpen(false);
        getAllReferralRequests();
      }
    } catch (error) {
      enqueueSnackbar(error, {
        variant: "error",
      });
    } finally {
    }
  };

  const deleteReferralInvite = async (_id) => {
    try {
      setIsLoading(true);
      const { success, data } = await deleteReferral(_id);
      if (success) {
        await getAllReferralRequests();
        enqueueSnackbar("Referral deleted successfully!", {
          variant: "success",
        });
      }
      setIsCancelInviteModal(false);
      setSelectedReferralId(null);
    } catch (error) {
      enqueueSnackbar("Oops! Something went wrong!", { variant: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  const removeReferralMember = async (_id) => {
    try {
      const { success, data } = await removeReferral(_id);
      if (success) {
        await getReferralDetail();
        setSelectedReferralMemberId(undefined);
        setActiveTab("invites");
        setIsCancelInviteModal(false);
        setIsRemoveReferralModal(false);
        enqueueSnackbar("Referral deleted successfully!", {
          variant: "success",
        });
      }
    } catch (error) {
      enqueueSnackbar("Oops! Something went wrong!", { variant: "error" });
    }
  };

  return (
    <div className="flex h-full min-h-0 w-full bg-white rounded-lg overflow-hidden p-6 gap-5">
      {loading ? (
        <div className="flex flex-1 flex-col items-center justify-center">
          <LoadingAnimation color={"black"} />
        </div>
      ) : (
        <>
          {!referralMember ? (
            <div className="w-1/3 h-[633px] bg-white border border-[#ECECEC] rounded-sm p-6 flex flex-col items-center gap-4">
              <p className="text-xs text-charcoal font-semibold mb-5">
                Your Referral Member
              </p>

              <div className="flex rounded-full h-[150px] w-[150px] items-center justify-center max-md:h-36 max-md:w-36">
                <img
                  src={userImg}
                  className="h-full w-full object-cover rounded-full"
                  alt="profileImg"
                />
              </div>

              <button
                className=" bg-light-white-700 px-12  py-2 font-semibold  text-xs  mt-4 border border-[#ececec] rounded-sm text-charcoal"
                onClick={handleChangeReferralClick}
              >
                Add Referral member
              </button>
            </div>
          ) : (
            <div className="w-1/3 h-[633px] bg-white border border-[#ECECEC] rounded-sm p-6 flex flex-col items-center gap-4">
              <p className="text-xs text-charcoal font-semibold mb-5">
                Your Referral Member
              </p>
              <p className="font-medium text-xs">{referralMember?.refNo}</p>

              <div className="flex rounded-full h-[150px] w-[150px] bg-[#E1E0E0] items-center justify-center max-md:h-36 max-md:w-36">
                {referralMember?.external === true ? (
                  <img
                    src={userImg}
                    className="rounded-full h-16 w-16 object-cover"
                    alt="profileImg"
                  />
                ) : referralMember?.profilePic ? (
                  <img
                    src={referralMember.profilePic}
                    className="h-full w-full object-cover rounded-full"
                    alt="profileImg"
                  />
                ) : (
                  <div className="flex rounded-full h-16 w-16 bg-[#E1E0E0] items-center justify-center">
                    <span className="font-montserrat text-white font-semibold text-6xl">
                      {referralMember?.firstName?.charAt(0).toUpperCase()}
                      {referralMember?.lastName?.charAt(0).toUpperCase()}
                    </span>
                  </div>
                )}
              </div>
              <div className="text-center">
                <p className="font-medium text-sm mb-3">
                  {referralMember?.firstName} {referralMember?.lastName}
                </p>
                <p className="text-sm text-gray-500 mb-3">
                  <span className="font-semibold text-xs pe-3">Username :</span>{" "}
                  {referralMember?.userName}
                </p>
                <a
                  href="#"
                  className="text-xs text-charcoal break-all mb-3 lowercase"
                >
                  {`https://comtracked/profile/${referralMember.userName}`}
                </a>
              </div>
              <button
                className=" bg-[#f7f7f7] px-12  py-2 font-semibold  text-xs  mt-4 border border-[#ececec] rounded-sm"
                onClick={handleChangeReferralClick}
              >
                Change Referral member
              </button>
              <button
                className="bg-[#f7f7f7] px-12  py-2 font-semibold  text-xs border border-[#ececec] rounded-sm"
                onClick={() => {
                  setSelectedReferralMemberId(referralMember.inviteId);
                  setIsRemoveReferralModal(true);
                }}
              >
                Remove Referral member
              </button>
              <p className="text-xs ont-medium text-charcoal mt-2">
                Your referral member since{" "}
                {dayjs(referralMember?.createdAt).format("DD/MM/YY")}
              </p>
            </div>
          )}

          <div className="flex flex-col w-2/3 bg-white overflow-hidden h-full min-h-0">
            <div className="flex border-b">
              <button
                className={`text-xs px-4 py-2 mb-1 ${
                  activeTab === "messages"
                    ? "font-semibold border-b-2 border-primary text-charcoal"
                    : "text-gray-500"
                }`}
                onClick={() => setActiveTab("messages")}
                disabled={isNullOrEmpty(referralMember)}
              >
                Messages
              </button>
              <button
                className={`text-xs px-4 py-2 mb-1 ${
                  activeTab === "tracker"
                    ? "font-semibold border-b-2 border-primary text-charcoal"
                    : "text-gray-500"
                }`}
                onClick={() => setActiveTab("tracker")}
                disabled
              >
                Tracker
              </button>
              <button
                className={`text-xs px-4 py-2 mb-1 ${
                  activeTab === "invites"
                    ? "font-semibold border-b-2 border-primary text-charcoal"
                    : "text-gray-500"
                }`}
                onClick={() => setActiveTab("invites")}
              >
                Invites
              </button>
            </div>

            {activeTab === "messages" && (
              <ReferralMemberMessages referral={referralMember} />
            )}

            {activeTab === "invites" && (
              <div className="flex-1 bg-white rounded-lg overflow-y-auto space-y-4 no-scrollbar">
                {isNullOrEmpty(referralRequestData) ? (
                  <div className="flex flex-col gap-6 items-center mt-40">
                    <p className="text-xs font-medium text-charcoal">
                      You don’t have any referral member added to your account.
                    </p>
                  </div>
                ) : (
                  <>
                    {referralRequestData.map((invite, index) => {
                      console.log(
                        "lodingId:",
                        loadingId?.requestId === invite._id,
                        loadingId,
                        invite._id
                      );

                      return (
                        <div
                          key={index}
                          className="flex flex-row items-center justify-between py-4 border-b"
                        >
                          <div className="flex-1">
                            <p
                              className={`text-xs mb-2 font-medium ${
                                invite.status === "approved"
                                  ? "text-[#23BD33]"
                                  : invite.status === "declined"
                                  ? "text-[#FF3B3B]"
                                  : "text-[#FF9800]"
                              }`}
                            >
                              {invite.status === "approved"
                                ? "Accepted"
                                : invite.status === "declined"
                                ? "Rejected"
                                : "Pending confirmation"}
                            </p>

                            <p className="text-xs mb-2 text-light-black">
                              {dayjs(invite?.createdAt).format(
                                "DD/MM/YY hh:mm"
                              )}
                            </p>
                            <p className="text-xs mb-2 text-charcoal font-medium">
                              {invite?.external === false
                                ? "Internal"
                                : "External"}{" "}
                              invite{" "}
                              {invite.createdBy === user?.userId
                                ? "sent"
                                : "received"}
                            </p>
                          </div>

                          <div className="flex flex-col items-center flex-1">
                            {invite?.external === true ? (
                              <img
                                src={userImg}
                                className="rounded-full h-16 w-16 object-cover"
                                alt="profileImg"
                              />
                            ) : invite?.referralId?.profilePic ? (
                              <img
                                src={invite?.referralId?.profilePic}
                                alt={invite?.name}
                                className="rounded-full h-16 w-16 object-cover"
                              />
                            ) : (
                              <div className="flex rounded-full h-16 w-16 bg-[#E1E0E0] items-center justify-center">
                                <span className="font-montserrat text-white font-semibold text-2xl">
                                  {invite?.referralId?.firstName
                                    ?.charAt(0)
                                    .toUpperCase()}
                                  {invite?.referralId?.lastName
                                    ?.charAt(0)
                                    .toUpperCase()}
                                </span>
                              </div>
                            )}

                            <p className="font-medium text-xs mt-2">
                              {invite?.referralId?.refNo || "-"}
                            </p>
                          </div>

                          {/* User Info */}
                          <div className="flex-1">
                            <p className="text-xs font-medium text-light-black">
                              {invite?.referralId?.firstName || "-"}{" "}
                              {invite?.referralId?.lastName || "-"}
                            </p>
                            {invite.username && (
                              <p className="text-xs text-charcoal">
                                <span className="font-semibold text-xs pe-3">
                                  Username :
                                </span>{" "}
                                {invite?.username || "-"}
                              </p>
                            )}
                            {invite.profileLink && (
                              <a className="text-xs text-light-black font-medium break-all">
                                {invite?.profileLink || "-"}
                              </a>
                            )}
                            {invite?.referralId?.email && (
                              <a className="text-xs text-light-black font-medium break-all">
                                {invite?.referralId?.email || "-"}
                              </a>
                            )}
                          </div>

                          <div
                            className={
                              invite.status === "declined"
                                ? "invisible flex flex-1"
                                : "flex gap-2 flex-1 justify-end "
                            }
                          >
                            {invite.status === "pending" &&
                            invite.createdBy !== user?.userId ? (
                              <div>
                                <button
                                  className={
                                    "bg-light-white-700 border border-[#ECECEC] rounded-sm p-2 min-w-10"
                                  }
                                  disabled={
                                    !isNullOrEmpty(isLoading) &&
                                    isLoading?._id === invite?._id
                                  }
                                  title="Custom Action 1"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    notificationRequestAction({
                                      requestId: invite?._id,
                                      action: "approved",
                                    });
                                  }}
                                >
                                  {!isNullOrEmpty(isLoading) &&
                                  isLoading?._id === invite?._id &&
                                  isLoading?.action === "approved" ? (
                                    <LoadingAnimation
                                      className="h-5 w-5 ml-0 mr-0"
                                      color={colors.black}
                                    />
                                  ) : (
                                    <CheckMark width={18} height={16} />
                                  )}
                                </button>
                                <button
                                  className={
                                    "bg-light-white-700 border items-center justify-center border-[#ECECEC] rounded-sm p-2 min-w-10"
                                  }
                                  title="Custom Action 2"
                                  disabled={
                                    !isNullOrEmpty(isLoading) &&
                                    isLoading?._id === invite?._id
                                  }
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    notificationRequestAction({
                                      requestId: invite?._id,
                                      action: "declined",
                                    });
                                  }}
                                >
                                  {!isNullOrEmpty(isLoading) &&
                                  isLoading?._id === invite?._id &&
                                  isLoading?.action === "declined" ? (
                                    <LoadingAnimation
                                      className="h-5 w-5 ml-0 mr-0"
                                      color={colors.black}
                                    />
                                  ) : (
                                    <CrossMark
                                      className={"ps-1"}
                                      width={18}
                                      height={16}
                                      fill={"#ffffff"}
                                    />
                                  )}
                                </button>
                              </div>
                            ) : (
                              <>
                                {invite.status !== "approved" &&
                                  invite.status !== "declined" && (
                                    <>
                                      <button
                                        className="bg-light-white-700 border border-[#ECECEC] rounded-sm p-2 opacity-100"
                                        title="Resend"
                                        onClick={() =>
                                          resendNewReferral({
                                            requestId: invite?._id,
                                          })
                                        }
                                      >
                                        <EmailInvite
                                          width={18}
                                          height={16}
                                          fill="#ffffff"
                                        />
                                      </button>

                                      <button
                                        className="bg-light-white-700 border border-[#ECECEC] rounded-sm p-2 opacity-100"
                                        title="Delete"
                                        onClick={() => {
                                          setSelectedReferralId(invite?._id);
                                          setIsCancelInviteModal(true);
                                        }}
                                      >
                                        <DeleteIcon width={18} height={16} />
                                      </button>
                                    </>
                                  )}

                                {invite.finalConfirmationTime &&
                                invite.status !== "pending" ? (
                                  <p className="text-xs px-2 text-gray-600">
                                    {dayjs(invite.finalConfirmationTime).format(
                                      "DD-MM-YYYY hh:mm A"
                                    )}
                                  </p>
                                ) : ["approved"].includes(invite.status) &&
                                  invite.createdBy === user?.userId ? (
                                  <button
                                    className="bg-light-white-700 border border-[#ECECEC] flex  rounded-sm py-2 px-3 text-sm"
                                    title="Confirm"
                                    onClick={() =>
                                      finalReferralConfirmation({
                                        requestId: invite._id,
                                      })
                                    }
                                  >
                                    {loadingId?.requestId === invite._id ? (
                                      <LoadingAnimation
                                        className="h-5 w-5 ml-0 mr-0"
                                        color={colors.black}
                                      />
                                    ) : (
                                      "Confirm"
                                    )}
                                  </button>
                                ) : null}
                              </>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </>
                )}
              </div>
            )}

            {isCancelInviteModal && (
              <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-50">
                <div className="bg-white p-6 flex flex-col rounded-md max-w-[409px] mx-4 ">
                  <div className="flex flex-col content-center items-center gap-4">
                    <p className="text-xl font-semibold text-charcoal top-8">
                      Want to cancel invite?
                    </p>

                    <CancelInviteIcon />

                    <p className="text-sm font-medium text-charcoal text-center">
                      Are you sure you want to cancel the referral member
                      invite?
                    </p>
                  </div>

                  <div className="flex flex-row mt-7 gap-3">
                    <button
                      onClick={handleCloseInviteModal}
                      className="flex w-[50%] self-end gap-2 font-bold bg-white justify-center items-center text-xs text-charcoal py-2 border border-primary rounded-sm "
                    >
                      Not now
                    </button>
                    <button
                      onClick={() => {
                        if (selectedReferralId) {
                          deleteReferralInvite(selectedReferralId);
                        }
                      }}
                      className={
                        "flex self-end gap-2 w-[50%] font-bold bg-primary justify-center items-center text-xs text-white border border-primary rounded-sm py-2 px-4 hover:bg-black"
                      }
                    >
                      {isLoading && (
                        <LoadingAnimation
                          color={colors.White}
                          className={"w-4 h-4"}
                        />
                      )}
                      Yes, cancel
                    </button>
                  </div>
                </div>
              </div>
            )}

            {isInviteModal && (
              <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-50">
                <div className="bg-white p-4 flex flex-col rounded-md max-w-[409px] mx-4">
                  <button
                    onClick={handleColseInviteModal}
                    className="flex self-end text-black text-xl font-semibold"
                  >
                    X
                  </button>
                  <div className="flex flex-col content-center items-center gap-4">
                    <p className="text-xl font-semibold text-charcoal top-8">
                      Successfully sent
                    </p>

                    <CancelInviteIcon />

                    <p className="text-sm font-medium text-charcoal text-center">
                      The invitation has been successfully resend to the
                      referral member - Joe Bloggs .
                    </p>
                  </div>
                </div>
              </div>
            )}

            {isRemoveReferralModal && (
              <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-50">
                <div className="bg-white p-6 flex flex-col rounded-md max-w-[409px] mx-4 ">
                  <div className="flex flex-col content-center items-center gap-4">
                    <CancelInviteIcon />

                    <p className="text-sm font-medium text-charcoal text-center">
                      Are you sure you want to remove the referral member
                    </p>
                  </div>

                  <div className="flex flex-row mt-7 gap-3">
                    <button
                      onClick={() => {
                        setIsRemoveReferralModal(false);
                      }}
                      className="flex w-[50%] self-end gap-2 font-bold bg-white justify-center items-center text-xs text-charcoal  py-2  border border-primary rounded-sm "
                    >
                      Not now
                    </button>
                    <button
                      onClick={() => {
                        if (selectedReferralMemberId) {
                          removeReferralMember(selectedReferralMemberId);
                        }
                      }}
                      className={
                        "flex self-end gap-2 w-[50%] font-bold bg-primary justify-center items-center text-xs text-white border border-primary rounded-sm py-2 px-4 hover:bg-black"
                      }
                    >
                      Yes, Remove
                    </button>
                  </div>
                </div>
              </div>
            )}

            {isChangeReferralModalOpen && (
              <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50  flex justify-center items-center z-50">
                <div className="bg-white p-6 rounded-md w-[30%]">
                  <button
                    onClick={handleChangeReferralModal}
                    className="flex justify-end text-black text-2xl font-semibold w-full"
                  >
                    X
                  </button>

                  <CustomInput
                    name="changeReferralName"
                    control={control}
                    errors={errors}
                    label="Change referral member"
                    rules={{
                      required: "This field is required.",
                    }}
                    placeholder="Enter referral member name"
                    renderRight={
                      <SearchIcon
                        className="w-6 h-6 self-center cursor-pointer"
                        fill={"#2e2e2e"}
                        onClick={() => setShowList(true)}
                      />
                    }
                  />
                  {fields?.refferalAccounts?.length > 0 && (
                    <ul className="mt-2 border border-gray-300 rounded-lg shadow-md overflow-y-auto max-h-48">
                      {fields?.refferalAccounts
                        ?.filter(
                          (item) => item?.refNo !== referralMember?.refNo
                        )
                        .map((item) => (
                          <li
                            key={item.id}
                            className="flex items-center justify-between p-2 text-sm font-medium cursor-pointer hover:bg-slate-100"
                            onClick={() => {
                              setValue("inviteReferralAccount", item);
                              setValue(
                                "changeReferralName",
                                `${item?.firstName} ${item?.lastName}`
                              );
                            }}
                          >
                            <div className="flex items-center gap-2">
                              <img
                                src={item?.profilePic || ProfileImg}
                                alt={`${item?.firstName} ${item?.lastName}`}
                                className="w-6 h-6 rounded-full object-cover"
                              />
                              <span>
                                {item?.firstName} {item?.lastName}
                              </span>
                            </div>
                            <span className="text-gray-500 text-xs">
                              {item?.refNo}
                            </span>
                          </li>
                        ))}
                    </ul>
                  )}

                  <div className="mt-20">
                    {fields?.inviteReferralAccount && (
                      <div className="flex flex-col">
                        <button
                          onClick={() =>
                            updateReferralAccount({
                              referralEmail:
                                fields?.inviteReferralAccount?.email,
                            })
                          }
                          className="flex self-end gap-2 mt-14 px-11 font-medium bg-primary text-xs text-white rounded-md py-2  hover:bg-black"
                        >
                          {fields.isLoadingInviteReferaalAccount && (
                            <LoadingAnimation />
                          )}
                          Save
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default ReferralMemberPage;
